import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import VueGoodTablePlugin from 'vue-good-table'
import VueAdsPagination, { VueAdsPageButton } from 'vue-ads-pagination'
import VueExcelXlsx from 'vue-excel-xlsx'
import VCalendar from 'v-calendar'
import moment from 'moment'

import '@babel/polyfill'
import 'vue-good-table/dist/vue-good-table.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'vue-ads-pagination/dist/vue-ads-pagination.css'

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.use(VueGoodTablePlugin)
Vue.use(VueExcelXlsx)
Vue.use(VCalendar)

Vue.component('vue-ads-pagination', VueAdsPagination)
Vue.component('vue-ads-page-button', VueAdsPageButton)

Vue.filter('decimalFormat', (num) => {
  if (typeof num == 'number') {
    return Number(num).toLocaleString(undefined, { minimumFractionDigits: 0 })
  } else {
    return '-'
  }
})

Vue.filter('datetimeFormat', (date) => {
  if (date) return moment(date).format('YYYY-MM-DD HH:mm:ss')
  else return '-'
})

Vue.filter('userStatusFormat', (statusName) => {
  let text
  switch (statusName) {
    case 'Normal':
      text = 'อาสาสมัคร RFB'
      break
    case 'Admin':
      text = 'แอดมิน'
      break
    case 'Blind':
      text = 'สมาชิก TAB 1414 Plus'
      break
    default:
      text = statusName
      break
  }

  return text
})

Vue.filter('genderFormat', (gender) => {
  let text
  switch (gender) {
    case 'male':
      text = 'ชาย'
      break
    case 'female':
      text = 'หญิง'
      break
    default:
      text = 'ไม่ระบุ'
      break
  }

  return text
})

Vue.prototype.$log = console.log.bind(console)

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
